import styled from 'styled-components';

import media from 'apps/auth/theme/media';

const shouldForwardItemContainerProp = (prop) => !['blackText'].includes(prop);

export const DocsListContainer = styled.ol`
    counter-reset: item;
    list-style-type: none;
    margin: 0 0 48px;
    padding: 0;
`;
export const ItemContainer = styled.li.withConfig({ shouldForwardProp: shouldForwardItemContainerProp })`
    font-size: 17px;
    line-height: 24px;
    color: ${(props) => (props.blackText ? props.theme.black : props.theme.grey_72_lc)};
    margin: 0 0 48px;

    &:last-child {
        margin-bottom: 0;
    }

    &:before {
        color: var(--blue-100);
        font-size: 24px;
        line-height: 36px;
        content: counter(item) '. ';
        counter-increment: item;
        display: block;
    }

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;

        &:before {
            font-size: 32px;
            line-height: 48px;
        }
    }
`;
export const Title = styled.div`
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 16px;
    color: ${(props) => props.theme.black};

    ${media.desktop1920} {
        font-size: 32px;
        line-height: 48px;
    }
`;

export const DocsTable = styled.div`
    margin-top: 32px;
`;
export const DocsTr = styled.div`
    display: flex;
    column-gap: 24px;
`;

export const DocsTd = styled.div`
    width: 50%;
    position: relative;
`;

export const DocsBitText = styled.span`
    position: absolute;
    left: 50%;
    margin-left: 48px;
    top: 56px;
    color: ${(props) => props.theme.grey_72_lc};
`;

export const DocsIllustration = styled.figure`
    margin-bottom: 24px;
    height: 136px;

    img {
        max-width: 100%;
        max-height: 100%;
    }
`;
